<div class="from">
  <div class="product-name">{{ currentPrice().product.name }}</div>
  @for (line of lines(); track $index) {
    <div class="value">{{ line.from }}</div>
  }
</div>

<div class="arrow">
  <img src="/assets/icons/special/checkout-arrow.svg" alt="" />
</div>

<div class="to">
  <div class="product-name">{{ price().product.name }}</div>
  @for (line of lines(); track $index) {
    <div class="value">
      @if (line.type === 'up') {
        <app-svg src="/assets/icons/16/up-arrow.svg" color="primary"></app-svg>
      } @else if (line.type === 'down') {
        <app-svg src="/assets/icons/16/down-arrow.svg" color="orange"></app-svg>
      } @else {
        <div class="icon-placeholder"></div>
      }

      {{ line.to }}
    </div>
  }
</div>
